/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { FunctionalActor } from '@sick-davinci/glow';
import * as Stats from 'three/examples/js/libs/stats.min';
export const addStatsWidget = (stage, verticalPosition = 'top', horizontalPosition = 'left', containerEl = document.body) => {
    const stats = new Stats();
    stage.addActor(new FunctionalActor(() => stats.update())); // actor is called every frame
    const el = stats.dom;
    el.style[verticalPosition] = '0';
    el.style[horizontalPosition] = '0';
    el.style[verticalPosition === 'top' ? 'bottom' : 'top'] = 'auto';
    el.style[horizontalPosition === 'left' ? 'right' : 'left'] = 'auto';
    containerEl.appendChild(el);
};
//# sourceMappingURL=addStatsWidget.js.map